<section class="sidebar">
    <ul class="sidebar-menu" data-widget="tree">
        <li class="active treeview"> <a  [routerLink]="['/dashboard']"> <i class="fa fa-home"></i> <span>Home</span> </a> </li>
        <li class="treeview"> <a  [routerLink]="['/pending-cases']"> <i class="fa fa-list-alt"></i> <span>Pending Cases</span> </a></li>
        <li class="treeview sidebar-products-menu" *ngIf="supplierProducts.length && showSidebarProducts">
            <div
              class="sidebar-products-title"
              (click)="toggleProductsExpanded()"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="productsExpanded"
            >
                <i class="fa fa-cubes"></i>
                <span>Products</span>
                <i class="fa sidebar-products-caret" [class.is-open]="productsExpanded"></i>
            </div>
            <ul class="sidebar-products-list" *ngIf="productsExpanded">
                <li
                  *ngFor="let item of supplierProducts"
                  (click)="setActiveProduct(item)"
                  [class.is-active]="(item.productID ?? item.ProductID ?? item.productId ?? item.ProductId) == activeProductId"
                  tabindex="0"
                  role="button"
                >
                    <span class="sidebar-products-name">{{ item.Product ?? item.product }}</span>
                    <!-- <span class="sidebar-products-id" *ngIf="item.productID != null || item.ProductID != null">({{ item.productID ?? item.ProductID }})</span> -->
                </li>
            </ul>
        </li>
        <!-- <li class="treeview"> <a  [routerLink]="['/claim-assignment']" *ngIf="LoginDetails.UserType==1 || (LoginDetails.UserType==2 && LoginDetails.InsurerId == 6 )"> <i class="fa fa-pencil-square-o"></i> <span>Claim Assignment</span> </a> </li> -->
        <!-- <li class="treeview"> <a  [routerLink]="['/claim-assignment']" > <i class="fa fa-pencil-square-o"></i> <span>Claim Assignment</span> </a> </li> -->
    </ul>
</section>
